import { Injectable } from "@angular/core";
import * as signalR from '@microsoft/signalr';

@Injectable({ providedIn: 'root' })
export class SignalRService {
  private connections: { [key: string]: signalR.HubConnection } = {};

  /**
   * `withCredentials` defaults to true in the SignalR client, which makes the browser demand
   * `Access-Control-Allow-Credentials` from the hub's CORS policy. Pass false for the anonymous
   * sync-worker hubs, whose policies allow origins only.
   */
  startConnection(name: string, url: string, options: { withCredentials?: boolean } = {}) {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(url, { withCredentials: options.withCredentials ?? true })
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then(() => console.log(`Connection ${name} started`))
      .catch(err => console.error(`Error starting ${name}:`, err));

    this.connections[name] = connection;
  }

  on<T = any>(name: string, method: string, callback: (data: T) => void) {
    this.connections[name]?.on(method, callback);
  }

  stopConnection(name: string) {
    this.connections[name]?.stop();
  }

  removeHandlers(name: string, method: string) {
    this.connections[name]?.off(method);
  }
}
